"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Content = exports.IconContainer = exports.Input = exports.ContentContainer = exports.PillsWrapper = exports.PillsComponentWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const colors_1 = require("../../../theme/colors");
exports.PillsComponentWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.PillsWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.ContentContainer = styled_components_1.default.label `
    border: 1px solid ${colors_1.GREY2};
    border-radius: ${theme_1.CORNER_RADIUS_SMALL};
    margin-right: 8px;
    padding: 7.5px 12px 8.5px 12px;
    &:hover {
        cursor: pointer;
    }
`;
exports.Input = styled_components_1.default.input `
    position: absolute;
    visibility: hidden;
    display: none;
    &:checked + ${exports.ContentContainer} {
        background: ${colors_1.PALE_GREEN};
        border: 2px solid ${colors_1.DARK_GREEN};
        box-sizing: border-box;
        border-radius: ${theme_1.CORNER_RADIUS_SMALL};
    }
`;
exports.IconContainer = styled_components_1.default.span ``;
exports.Content = styled_components_1.default.span `
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.2px;
    color: ${colors_1.BLACK};
`;
exports.Label = styled_components_1.default.span `
    font-family: SwegonBrown;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.2px;
    color: ${colors_1.BLACK};
`;
//# sourceMappingURL=Pills.styles.js.map